import { render, staticRenderFns } from "./Servico-resumo.vue?vue&type=template&id=57631be1&scoped=true"
import script from "./Servico-resumo.vue?vue&type=script&lang=js"
export * from "./Servico-resumo.vue?vue&type=script&lang=js"
import style0 from "./Servico-resumo.vue?vue&type=style&index=0&id=57631be1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57631be1",
  null
  
)

export default component.exports